/* istanbul ignore file */
import React from 'react';
import { type ChooChooLivePreviewProps } from './ChooChooLivePreviewProps';

// Using React.lazy to dynamically load ChooChooLivePreview to prevent
// @content-stack/live-preview-utils from making it into initial bundle.
const ChooChooLivePreview = React.lazy(() => import('./ChooChooLivePreview'));

function ChooChooLivePreviewVM(props: ChooChooLivePreviewProps) {
  return <ChooChooLivePreview {...props} />;
}

export default ChooChooLivePreviewVM;
